export const discountNightValue = (value: number, formatted?: boolean) => {
    const discount = value * 0.1
    if (formatted) {
        return (value - discount).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
    return Number((value - discount).toFixed(2))
}


export const discountMidStayValue = (typePayment: string ,valueMidStay: number, condominium: number, iptu: number, cleaningValue: number, yoghaPack: number, totalValue: number) => {
    if (typePayment === 'PIX') {
        const sumOtherValues = condominium + iptu + cleaningValue + yoghaPack
        return (discountNightValue(valueMidStay) as number) + sumOtherValues
    } else {
        return totalValue
    }
}
export const discountValue = (value: number, formatted?: boolean) => {
    const discount = value * 0.1
    if (formatted) {
        return discount.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
        return discount
}

export const valueUndiscount = (value: number, cleaningValue: number) => {
    const orinalValue = value + cleaningValue
    return orinalValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}